(function ($) {

    $.paginate = function (element, options) {

        //Defaults
        var defaults = {
            perPage: 6, //items per page
            minPagesToShow: 2, //minmal pages available to inititalize pagination
            range: 0, //show pages in range, 0 = disabled
            autoScroll: false, //boolean: scroll to top of the container if a user clicks on a pagination link
            scope: '', //which elements to target
            paginatePosition: ['bottom'], //defines where the pagination will be displayed | top,bottom or use jquery selector for specific position
            containerTag: 'nav',
            paginationTag: 'ul',
            itemTag: 'li',
            linkTag: 'a',
            useHashLocation: false, //Determines whether or not the plugin makes use of hash locations
            hidePaginate: false,
            onPageClick: function () { //Triggered when a pagination link is clicked
            }
        };

        var plugin = this;

        plugin.settings = {};

        var $element = $(element);
        var plugin_index = $element.attr('id') || $('.paginate').length;

        var curPage, items, offset, maxPage;

        //Initliazes plugin
        plugin.init = function () {
            plugin.settings = $.extend({}, defaults, $element.data(), options);

            curPage = 1;
            items = $element.find(plugin.settings.scope);
            maxPage = Math.ceil(items.length / plugin.settings.perPage); //determines how many pages exist

            if (maxPage < plugin.settings.minPagesToShow) {
                this.destroy();
                return false;
            }

            $element.addClass('paginate');
            $element.addClass('paginate-' + plugin_index);

            plugin.renderPagination();
            plugin.registerEventListener();

            var hash = location.hash.match(/\#paginate\-(\d)/i);

            //Check if URL has matching location hash
            if (hash && plugin.settings.useHashLocation) {
                plugin.switchPage(hash[1]);
            } else {
                plugin.switchPage(1); //go to initial page
            }

            if (plugin.settings.hidePaginate) {
                plugin.hidePagination();
            }
        };

        /*
            #Switch to Page > 'page'
        */
        plugin.switchPage = function (page) {

            if (page === "next") {
                page = curPage + 1;
            }

            if (page === "prev") {
                page = curPage - 1;
            }

            curPage = page;
            if (plugin.settings.range > 0) {
                plugin.renderPagination();
            }

            //If page is out of range return false
            if (page < 1 || page > maxPage) {
                return false;
            }

            if (page > maxPage) {
                $('.paginate-pagination-' + plugin_index).find('.page-next').addClass('disabled');
                return false;
            } else {
                $('.paginate-pagination-' + plugin_index).find('.page-next').removeClass('disabled');
            }

            $('.paginate-pagination-' + plugin_index).find('.active').removeClass('active');
            $('.paginate-pagination-' + plugin_index).find('.page-' + page).parent().addClass('active');

            offset = (page - 1) * plugin.settings.perPage;

            $(items).hide();

            //Display items of page
            for (i = 0; i < plugin.settings.perPage; i++) {
                if ($(items[i + offset]).length)
                    $(items[i + offset]).fadeTo(100, 1);
            }

            //Deactive prev button
            if (page === 1) {
                $('.paginate-pagination-' + plugin_index).find('.page-prev').addClass("disabled");
            } else {
                $('.paginate-pagination-' + plugin_index).find('.page-prev').removeClass("disabled");
            }

            //Deactive next button
            if (page === maxPage) {
                $('.paginate-pagination-' + plugin_index).find('.page-next').addClass("disabled");
            } else {
                $('.paginate-pagination-' + plugin_index).find('.page-next').removeClass("disabled");
            }

            curPage = page;

            $('.paginate-pagination-' + plugin_index).trigger('paginate:switchPage', curPage);

            return curPage;

        };

        /*
        #destroy plugin
        */
        plugin.destroy = function () {

            $(items).show();
            $('.paginate-pagination-' + plugin_index).remove();
            $element.removeClass('paginate');
            $element.removeData('paginate');

        };

        /*
        #hide pagination bar
        */
        plugin.hidePagination = function () {
            $('.paginate-pagination-' + plugin_index).hide();
        };

        /*
        #show pagination bar
        */
        plugin.showPagination = function () {
            $('.paginate-pagination-' + plugin_index).show();
        };

        plugin.renderPagination = function () {
            var paginationHTML = generatePagination(); //generate HTML for pagination

            if ($.isArray(plugin.settings.paginatePosition)) {
                //array
                $('.paginate-pagination-' + plugin_index).remove();
                if ($.inArray('top', plugin.settings.paginatePosition) > -1) {
                    $element.before(paginationHTML);
                }

                if ($.inArray('bottom', plugin.settings.paginatePosition) > -1) {
                    $element.after(paginationHTML);
                }
            } else {
                //string
                var targetContainer = $(plugin.settings.paginatePosition, $element);
                if (targetContainer.length === 0) {
                    targetContainer = $element.closest(plugin.settings.paginatePosition);
                }
                if (targetContainer.length === 0) {
                    targetContainer = $element.parent().next(plugin.settings.paginatePosition);
                }
                if (targetContainer.length === 0) {
                    targetContainer = $element.next(plugin.settings.paginatePosition);
                }
                if (targetContainer.length === 0) {
                    this.destroy();
                    return false;
                }
                targetContainer.html(paginationHTML);
            }
        };

        plugin.registerEventListener = function () {
            //Adds event listener for the buttons
            $(document).on('click', '.paginate-pagination-' + plugin_index + ' .page', function (e) {
                e.preventDefault();

                var page = $(this).data('page');
                var paginateParent = $(this).parents('.paginate-pagination').data('parent');

                //Call onPageClick callback function
                $('.paginate-' + paginateParent).data('paginate').settings.onPageClick();

                page = $('.paginate-' + paginateParent).data('paginate').switchPage(page);

                if (page) {
                    if (plugin.settings.useHashLocation)
                        location.hash = '#paginate-' + page; //set location hash

                    if (plugin.settings.autoScroll)
                        $('html, body').animate({scrollTop: $('.paginate-' + paginateParent).offset().top}, 'slow');

                }

            });
        }

        /*
        #Generates HTML for pagination (nav)
        */
        var generatePagination = function () {

            var paginationEl = '<' + plugin.settings.containerTag + ' class="paginate-pagination paginate-pagination-' + plugin_index + '" data-parent="' + plugin_index + '">';
            paginationEl += '<' + plugin.settings.paginationTag + ' class="pagination justify-content-center">';

            paginationEl += '<' + plugin.settings.itemTag + ' class="page-prev page-item">';
            paginationEl += '<' + plugin.settings.linkTag + ' href="#" data-page="prev" class="page page-link">&laquo;</' + plugin.settings.linkTag + '>';
            paginationEl += '</' + plugin.settings.itemTag + '>';

            if (plugin.settings.range > 0) {
                var delta = Math.floor(plugin.settings.range / 2),
                    left = curPage - delta,
                    right = curPage + delta + 1;
                if (left < 0) {
                    right += (left * -1);
                }

                var rangeH = [], rangeWithDots = [], l;
                for (let i = 1; i <= maxPage; i++) {
                    if (i === 1 || i === maxPage || i >= left && i < right) {
                        rangeH.push(i);
                    }
                }
                for (let i of rangeH) {
                    if (l) {
                        if (i - l === 2) {
                            rangeWithDots.push(l + 1);
                        } else if (i - l !== 1) {
                            rangeWithDots.push('...');
                        }
                    }
                    rangeWithDots.push(i);
                    l = i;
                }

                for (let i of rangeWithDots) {
                    if ('...' === i) {
                        paginationEl += '<' + plugin.settings.itemTag + ' class="page-item">';
                        paginationEl += '<' + plugin.settings.linkTag + ' href="#" class="page page-link cursor-default">' + i + '</' + plugin.settings.linkTag + '>';
                        paginationEl += '</' + plugin.settings.itemTag + '>';
                    } else {
                        paginationEl += '<' + plugin.settings.itemTag + ' class="page-item">';
                        paginationEl += '<' + plugin.settings.linkTag + ' href="#paginate-' + i + '" data-page="' + i + '" class="page page-link page-' + i + '">' + i + '</' + plugin.settings.linkTag + '>';
                        paginationEl += '</' + plugin.settings.itemTag + '>';
                    }
                }

            } else {
                for (i = 1; i <= maxPage; i++) {
                    paginationEl += '<' + plugin.settings.itemTag + ' class="page-item">';
                    paginationEl += '<' + plugin.settings.linkTag + ' href="#paginate-' + i + '" data-page="' + i + '" class="page page-link page-' + i + '">' + i + '</' + plugin.settings.linkTag + '>';
                    paginationEl += '</' + plugin.settings.itemTag + '>';
                }
            }

            paginationEl += '<' + plugin.settings.itemTag + ' class="page-next page-item">';
            paginationEl += '<' + plugin.settings.linkTag + ' href="#" data-page="next" class="page page-link">&raquo;</' + plugin.settings.linkTag + '>';
            paginationEl += '</' + plugin.settings.itemTag + '>';

            paginationEl += '</' + plugin.settings.paginationTag + '>';
            paginationEl += '</' + plugin.settings.containerTag + '>';

            return paginationEl;

        };

        plugin.init();

    };

    $.fn.paginate = function (options) {

        return this.each(function () {
            if (undefined === $(this).data('paginate')) {
                var plugin = new $.paginate(this, options);
                $(this).data('paginate', plugin);
            }
        });

    };

}(jQuery));
